import {
  ITaxConnectionBaseSchema,
  TaxProviderTypeEnum,
  TaxStatusEnum,
} from '@monetize/types/app';

/**
 * Providers that support account-level tax exemption, i.e. the Tax Exemption
 * Number and Tax Exemption Reason (entity use code) fields on an account.
 */
const TAX_EXEMPTION_PROVIDERS = new Set<TaxProviderTypeEnum>([
  TaxProviderTypeEnum.AVALARA,
  TaxProviderTypeEnum.TAXWIRE,
]);

/**
 * True when the tenant has an active tax connection with a provider that
 * supports account-level tax exemption.
 */
export const isTaxExemptionSupported = (
  taxConnections?: ITaxConnectionBaseSchema[] | null,
): boolean =>
  !!taxConnections?.some(
    ({ provider, status }) =>
      TAX_EXEMPTION_PROVIDERS.has(provider) && status === TaxStatusEnum.ACTIVE,
  );
